import Repository from './Repository';
import ListRequest from '@/models/ListRequest';
import CustomerNew from '@/models/Customer/CustomerNew';
import SignupDto from '@/models/Restaurants/SignupDto';
import CustomerEdit from '@/models/Customer/CustomerEdit';
import CustomerActive from '@/models/Customer/CustomerActive';
import UpdateRestaurantProfile from '@/models/Customer/UpdateRestaurantProfile';
import { CreateRestaurantEmployee } from '@/models/Customer/CreateRestaurantEmployee';
import { UpdateRestaurantEmployee } from '@/models/Customer/UpdateRestaurantEmployee';
import UpdateRestaurantAccountProfile from '@/models/User/UpdateRestaurantAccountProfile';
import UpdateDatabase from '@/models/User/UpdateDatabase';
import { AxiosResponse } from 'axios';
import { VoidResult } from './ResultTypes/VoidResult';


const resource = '/restaurants';

export default {
  signup(signupDto: SignupDto) {
    return Repository.post(`${resource}/signup`, signupDto, { withCredentials: true });
  },
  fetchCustomersList(listRequest: ListRequest) {
    return Repository.post(`${resource}/listrestaurants`, listRequest, { withCredentials: true });
  },
  newCustomer(newCustomer: CustomerNew) {
    return Repository.post(`${resource}/createRestaurant`, newCustomer, { withCredentials: true });
  },
  editCustomer(editCustomer: CustomerEdit) {
    return Repository.post(`${resource}/updateRestaurant`, editCustomer, { withCredentials: true });
  },
  activeCustomer(customerActive: CustomerActive) {
    return Repository.post(`${resource}/updaterestaurantstatus`, customerActive, { withCredentials: true });
  },
  getRestaurantProfile() {
    return Repository.get(`${resource}/getrestaurantprofile`, { withCredentials: true });
  },
  updateRestaurantProfile(restaurantProfile: UpdateRestaurantProfile) {
    return Repository.post(`${resource}/updaterestaurantprofile`, restaurantProfile, { withCredentials: true });
  },
  listRestaurantEmployees(listRequest: ListRequest, restaurantId: number) {
    return Repository.post(`${resource}/ListRestaurantEmployees`, { queryOptions: listRequest.queryOptions, restaurantId }, { withCredentials: true });
  },
  createRestaurantEmployee(createRestaurantEmployee: CreateRestaurantEmployee) {
    return Repository.post(`${resource}/CreateRestaurantEmployee`, createRestaurantEmployee, { withCredentials: true });
  },
  updateRestaurantEmployee(updateRestaurantEmployee: UpdateRestaurantEmployee) {
    return Repository.post(`${resource}/UpdateRestaurantEmployee`, updateRestaurantEmployee, { withCredentials: true });
  },
  deleteRestaurant(id: number) {
    return Repository.post(`${resource}/deleteRestaurant`, { restaurantId: id }, { withCredentials: true });
  },
  deleteRestaurantEmployee(id: number) {
    return Repository.post(`${resource}/deleteRestaurantEmployee`, { userId: id }, { withCredentials: true });
  },
  enableRestaurantEmployee(id: number) {
    return Repository.post<number, AxiosResponse<VoidResult>>(
      `${resource}/EnableRestaurantEmployee`,
      { userId: id },
      { withCredentials: true }
    );
  },
  updateRestaurantAccountProfile(restaurantProfile: UpdateRestaurantAccountProfile) {
    return Repository.post(`${resource}/updaterestaurantprofile`, restaurantProfile, { withCredentials: true });
  },
  updateDatabase(id: UpdateDatabase) {
    return Repository.post(`${resource}/UpdateRestaurantDefaultNutrientSource`, id, { withCredentials: true });
  },
  updateRestaurantArchiveStatus(id: number, isArchived: boolean) {
    return Repository.post(`${resource}/UpdateRestaurantArchiveStatus`, { restaurantId: id, isArchived: isArchived }, { withCredentials: true });
  },
  listRestaurantsAsLookups() {
    return Repository.get(`${resource}/ListRestaurantsAsLookups`, { withCredentials: true });
  },
};
